// extracted by mini-css-extract-plugin
export default {"routerLink":"RouterLink_routerLink__B9mlD"};